export const budgetExpensesData = [
  {
    ExpenseName: "Servers",
    CategoryName: "Technology",
    SubCategoryName: "Hardware Cost",
    Amount: "20000",
    ExpenseDate: "14/01/2024",
    key: "1",
  },
  {
    ExpenseName: "Payroll Tax",
    CategoryName: "Taxes",
    SubCategoryName: "Payroll Taxes",
    Amount: "40000",
    ExpenseDate: "21/01/2024",
    key: "1",
  },
  {
    ExpenseName: "Job Fair 2024",
    CategoryName: "Recruitment",
    SubCategoryName: "Advertisement",
    Amount: "10000",
    ExpenseDate: "10/02/2024",
    key: "1",
  },
  {
    ExpenseName: "Annual Meet",
    CategoryName: "Corporate Events",
    SubCategoryName: "Decorations",
    Amount: "20000",
    ExpenseDate: "18/02/2024",
    key: "1",
  },
];
